import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap, faListUl, faSlidersH } from "@fortawesome/free-solid-svg-icons";

const ListHeaderButtons = ({toggleMap, mapIsOpen, toggleFilter}: any) => {
  return (
    <>
      <MapContainer onClick={toggleMap}>
          <MapItem>
            <MapIcon icon={mapIsOpen ? faListUl : faMap} />
            <MapText>{mapIsOpen ? "Liste" : "Harita"}</MapText>
          </MapItem>
        </MapContainer>

        <FilterContainer onClick={toggleFilter}>
          <MapItem>
            <MapIcon icon={faSlidersH} />
            <MapText>Filtreler</MapText>
          </MapItem>
        </FilterContainer>
    </>
  )
}


const MapContainer = styled.div`
  position: fixed;
  bottom: 40px;
  margin: auto 0;
  width: 100%;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  @media (max-width: ${(props) => props.theme.size.laptop}) {
    bottom: 75px;
  }
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    left: -10%;
  }
  @media (max-width: ${(props) => props.theme.size.mobileXl}) {
    left: -17%;
  }
`;

const FilterContainer = styled.div`
  position: fixed;
  bottom: 40px;
  margin: auto 0;
  width: 100%;
  left: 0px;
  right: 0px;
  justify-content: center;
  align-items: center;
  z-index: 1;
  display: none;
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    left: 10%;
    bottom: 75px;
    display: flex;
  }
  @media (max-width: ${(props) => props.theme.size.mobileXl}) {
    left: 17%;
  }
`;

const MapItem = styled.div`
  border-radius: 10px;
  display: inline-flex !important;
  border-radius: 24px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  outline: none !important;
  margin: 0px !important;
  padding: 11px 19px !important;
  color: rgb(34, 34, 34) !important;
  cursor: pointer !important;
  touch-action: manipulation !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: none !important;
  transition: -ms-transform 0.25s ease 0s, -webkit-transform 0.25s ease 0s,
    transform 0.25s ease 0s !important;
  background: rgb(34, 34, 34) !important;
`;

const MapText = styled.span`
  color: white;
  font-size: 12px;
  font-weight: 600;
`;

const MapIcon = styled(FontAwesomeIcon)`
  width: 14px;
  height: 14px;
  margin-right: 6px;
  * {
    color: white;
  }
`;

export default ListHeaderButtons;